import { Component } from '@angular/core';

import { TripBrw } from '../trip/trip_brw';
import { AddressBrw } from '../address/address_brw';
import { HomePage } from '../home/home';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = TripBrw;
  tab3Root = AddressBrw;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts